import * as Sentry from '@sentry/nextjs'
// Not re-exported by @sentry/nextjs — comes from its direct dependency (version-locked).
import { graphqlClientIntegration } from '@sentry/browser'
import { scrubSentryEventAndLinkTokens } from '@/lib/monitoring/sentry-scrub-links'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || undefined,
  environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE || undefined,
  // GlitchTip drops transactions/replay/profiles — don't waste ingest bandwidth.
  tracesSampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? 0),
  sendDefaultPii: false,
  integrations: [
    // Annotates failed GraphQL HTTP requests with operation name/type.
    graphqlClientIntegration({ endpoints: [/\/v1\/graphql/] }),
  ],
  // Shared scrubber (see lib/monitoring/sentry-scrub.ts). Supersedes the
  // hand-rolled cookie/authorization delete that used to live here: that one
  // missed x-hasura-admin-secret, query strings and request bodies entirely.
  beforeSend: scrubSentryEventAndLinkTokens,
  // Traces skip beforeSend: a page-load transaction is named after the raw path (`/o/<token>`).
  beforeSendTransaction: scrubSentryEventAndLinkTokens,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
